export default "__VITE_ASSET__CVFrDiNS__"